import { Breadcrumbs, Typography, Link } from "@mui/material";
import { PageTopBar, ThreeSlotLayout } from "../../../../../common/components/page_top_bar";
import AlertError from "../../../../../common/components/alert_error";
import PrimaryButton from "../../../../../common/components/primary_button";
import RefreshButton from "../../../../../common/components/refresh_button";
import StatCard from "../../../../../common/components/statCard";
import { usePrincipalFinanceiroViewModel } from "../../viewModels/principal_financeiro_view_model";
import { FluxoCaixaChart } from "./components/graficoFluxoCaixa";
import { ReportViewerModal } from "../../../../../common/components/report_viewer_modal";
import { FluxoDeCaixaReportModal } from "./components/fluxo_caixa_report_modal";
import PrincipaisDocGrid from "../../../../../common/components/principaisDocGrid";

/**
 * PrincipalFinanceiro
 */

export const PrincipalFinanceiro = () => {

    const viewModel = usePrincipalFinanceiroViewModel();

    return (
        <>
            <PageTopBar>
                <ThreeSlotLayout
                    rightSlot={
                        <div className="flex flex-row gap-2">
                            <div className="w-[10rem]">
                                <PrimaryButton
                                    buttonColor="yellow"
                                    onClick={viewModel.handleRelatorio}>
                                    Gerar relatório
                                </PrimaryButton>
                            </div>
                        </div>
                    }
                />
            </PageTopBar>

            {/**
        * Page
        */}

            <div className="flex w-full gap-2 flex-col py-2 px-4 mb-20">
                <Breadcrumbs aria-label="breadcrumb" className="cursor-pointer">
                    <Link underline="hover" color="inherit">
                        Financeiro
                    </Link>
                    <Typography className="text-primary-green">
                        Principal Financeiro
                    </Typography>
                </Breadcrumbs>

                <div className="div flex justify-between items-center flex-col md:flex-row gap-6 md:gap-0">
                    <div className="flex gap-2 items-center w-full">
                        <h1 className="text-3xl font-medium text-black dark:text-white"> Principal Financeiro </h1>
                        <RefreshButton onClick={viewModel.handleReload} />
                    </div>

                    <div className="w-full justify-end flex gap-2"></div>
                </div>
                {
                    viewModel.errorMessage !== undefined
                        ? (
                            <div className="w-full">
                                <AlertError
                                    messageErro={viewModel.errorMessage}
                                    onTryAgain={viewModel.handleReload} />
                            </div>
                        ) : (
                            <>
                                {
                                    viewModel.dashboardFinanceiroInformation !== null && (
                                        <div className="w-full flex flex-col gap-4 mb-8">
                                            <div>
                                                <FluxoCaixaChart
                                                    loading={viewModel.loading}
                                                    ano={viewModel.filtroAno}
                                                    dados={viewModel.dashboardFinanceiroChart}
                                                    onAnoChange={(novoAno) => viewModel.handleAnoChange(novoAno)}
                                                    onMesChange={(novoMes) => viewModel.handleMesChange(novoMes)}
                                                />
                                            </ div>

                                            <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 2xl:grid-cols-4 gap-4">
                                                <StatCard
                                                    title='Contas a pagar em atraso'
                                                    value={viewModel.dashboardFinanceiroInformation.nroContasPagarAtrasadas}
                                                    icon={"symbol"}
                                                    colorClass={{
                                                        bg: 'bg-red-500',
                                                        text: 'text-white',
                                                        bgHover: 'bg-red-600',
                                                    }}
                                                    linkText='Ver detalhes'
                                                    onClick={() => viewModel.handleCardClick(viewModel.cardIds.contasPagarAtraso)}
                                                />

                                                <StatCard
                                                    title='Contas a receber em atraso'
                                                    value={viewModel.dashboardFinanceiroInformation.nroContasReceberAtrasadas}
                                                    icon={"symbol"}
                                                    colorClass={{
                                                        bg: 'bg-zinc-500',
                                                        text: 'text-white',
                                                        bgHover: 'bg-zinc-600',
                                                    }}
                                                    linkText='Ver detalhes'
                                                    onClick={() => viewModel.handleCardClick(viewModel.cardIds.contasReceberAtraso)}
                                                />

                                            </div>
                                        </div>
                                    )
                                }
                            </>
                        )
                }
            </div>

            <FluxoDeCaixaReportModal
                open={viewModel.openRelatorioModal}
                saving={viewModel.loading}
                ddlCentroCusto={viewModel.ddlCentroCusto}
                ddlBanco={viewModel.ddlBanco}
                ddlFornecedor={viewModel.ddlFornecedor}
                ddlCliente={viewModel.ddlCliente}
                onClose={() => viewModel.handleRelatorioOpenState(false)}
                onSubmit={viewModel.handleFluxoCaixaReportSubmit}
            />

            <ReportViewerModal
                reportViewerState={viewModel.reportViewerState}
            />

            <PrincipaisDocGrid
                loading={viewModel.loading}
                rows={viewModel.docLista}
                totalItems={viewModel.pagination.totalItems}
                page={viewModel.pagination.page}
                rowsPerPage={viewModel.pagination.rowsPerPage}
                onPageChange={(p) => viewModel.handlePageChange(p)}
                onRowsPerPageChange={(p) => viewModel.handleRowsPerPageChange(p)}
                onActionExportar={(IdArquivoModulo, NomeArquivo) => viewModel.handleDownloadFile(IdArquivoModulo, NomeArquivo)}
            />

        </>
    );
}
